import { cn } from '@nesso/ui/lib/utils';

import { formatNumberToTimeFormat } from '@/shared/lib/time-utils';

interface TimerProps {
    time?: string | number;
    className?: string;
}

export function Timer({ time = '00:00', className }: TimerProps) {
    return (
        <div
            className={cn('text-[5rem] leading-[5rem]  text-border font-semibold', className)}
            aria-label="Recording timer"
        >
            {typeof time === 'number' ? formatNumberToTimeFormat(time) : time}
        </div>
    );
}
